<template>
    <div v-loading="loadingPage">
        <div>
            <div style="float: right">
                <el-select
                    filterable
                    v-model="valueSelectService" placeholder="Select additional service">
                    <el-option
                        v-for="(item, idx) in options"
                        :key="idx"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>&nbsp;
                <el-button type="primary" :loading="loadingBtnAddServiceAdditional" @click="addServiceAdditionalUser" icon="el-icon-plus"></el-button>
            </div>
            
            <div>
                <el-select
                    filterable
                    v-model="selectedProductAssigned" placeholder="Select product" style="width:33%;">
                    <el-option
                        v-for="(prd, key) in listProduct"
                        :key="key"
                        :label="prd.productSKU"
                        :value="prd.type">
                    </el-option>
                </el-select>&nbsp;
                <el-button type="primary" icon="el-icon-plus" @click="addProductAdditionalUser" :loading="loadingBtnAddProductAdditional"></el-button>
            </div>
        </div>
        <div v-if="services.length == ''">
            <img src="../../assets/images/no_data.png" alt="No data image" class="img-center" />
        </div>
        <div v-else v-for="(data, keyla) in services" :key="'a+'+keyla" class="mt-20" v-loading="getAdditionalServiceLoading">
            <div v-if="data.services == ''">
                <img src="../../assets/images/no_data.png" alt="No data image" class="img-center" />
            </div>
            <el-card v-else style="color:white; background: linear-gradient(45deg, rgb(85,85,85,1) 0%, rgba(36, 147, 147) 100%);">
                Service Name : 
                <span v-if="data.serviceName!=null">{{data.serviceName}}<br><br> 
                    <span v-for="(a, x) in data.product" :key="x">
                        <span style="font-weight: bold">{{a.productName}}</span><br>
                        <span style="font-weight: bold">Product Type :</span> {{capitalizeFirstLetter(a.type)}}<br>
                        <span style="font-weight: bold">Max Account :</span> {{a.max_account}}<br>
                        <span style="font-weight: bold">Product Price :</span> {{formatPrice(a.price)}}<br>
                        <span style="font-weight: bold">Product Minimum Price :</span> {{formatPrice(a.minPrice)}}<br>
                    </span> 
                    <div style="float: right">
                    <el-tooltip content="Delete Service" placement="top" style="margin-bottom: 20px;">
                        <!-- <el-button size="mini" v-if="data.serviceName=='promo_telkomsel'" disabled icon="el-icon-delete" type="danger" style="float:right;"></el-button> -->
                        <el-button size="mini" icon="el-icon-delete" type="danger" style="float:right;" :loading="additionalServiceLoadingButton" @click="removeAdditionalService(data.serviceName)"></el-button>
                    </el-tooltip>
                    </div>
                </span>
                <span v-else>-</span>
            </el-card>
        </div>
        <div class="page-profile-edit mt-20" v-for="(data, key) in product" :key="key" v-loading="loadingConsumenProductAdditional">
            <el-card v-if="product.length > 0" class="card-base scrollable only-y" style="color:white; background: linear-gradient(45deg, rgb(85,85,85,1) 0%, rgba(36, 147, 147) 100%);">
                <span style="float:right;">
                    <el-button type="default" @click="doShowDialogUpdateProduct(key)"><span class="mdi mdi-pencil"></span> Update Product Count</el-button>
                    <el-button icon="el-icon-delete" type="danger" :loading="loadingBtnRemoveProductAdditional" @click="removeProductAdditional(data._id)">Delete Product</el-button>
                </span>
                <table>
                    <tbody>
                        <tr>
                            <td colspan="2">
                                <dd>{{ data.productName }}</dd>
                                <dd>
                                    <el-col :span="16" :md="16" :sm="24" :xs="24" class="col-p">
                                        <span style="font-weight: bold">{{ $t('consumen.product.type') }}</span>
                                    </el-col>
                                    <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
                                        {{ capitalizeFirstLetter(data.type) }}
                                    </el-col>
                                </dd>
                                <!-- <dd>
                                    <el-col :span="20" :md="20" :sm="24" :xs="24" class="col-p">
                                        <span style="font-weight: bold">{{ $t('consumen.product.count') }}</span>
                                    </el-col>
                                    <el-col :span="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        {{ data.count }}
                                    </el-col>
                                </dd> -->
                                <dd>
                                    <el-col :span="20" :md="20" :sm="24" :xs="24" class="col-p">
                                        <span style="font-weight: bold">{{ $t('consumen.product.max_account') }}</span>
                                    </el-col>
                                    <el-col :span="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        {{ data.max_account }}
                                    </el-col>
                                </dd>
                                <dd>
                                    <el-col :span="20" :md="20" :sm="24" :xs="24" class="col-p">
                                        <span style="font-weight: bold">{{ $t('consumen.product.price') }}</span>
                                    </el-col>
                                    <el-col :span="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        {{ formatPrice(data.price) }}
                                    </el-col>
                                </dd>
                                <dd>
                                    <el-col :span="20" :md="20" :sm="24" :xs="24" class="col-p">
                                        <span style="font-weight: bold">{{ $t('consumen.product.minPrice') }}</span>
                                    </el-col>
                                    <el-col :span="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        <template>
                                        <span v-if="data.minPrice=='' || data.minPrice==null">-</span>
                                        <span v-else>{{ formatPrice(data.minPrice) }}</span>
                                        </template>
                                    </el-col>
                                </dd>
                                <dd v-if="data.type.indexOf('tier') != -1">
                                    <el-col :span="20" :md="20" :sm="24" :xs="24" class="col-p">
                                        <span style="font-weight: bold">{{ $t('consumen.product.tier') }}</span>
                                    </el-col>
                                    <el-col :span="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        <template>
                                            <el-row v-for="(tier, index) in data.tier" :key="index">
                                                <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                    <span>{{ formatPrice(tier.price) }} ({{ tier.from.toLocaleString() }} to {{ tier.to == "-" ? '&#8734;' : tier.to.toLocaleString() }})</span>
                                                </el-col>
                                            </el-row>
                                        </template>
                                    </el-col>
                                </dd>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </el-card>
            <el-alert v-else title="Info" type="info" :closable="false" description="No Data" show-icon></el-alert>
        </div>

        <el-dialog title="Update Product" :visible.sync="dialogUpdateProduct">
            <el-form>
                <el-form-item>
                    <el-input type="text" v-model="selectedProductCount" disabled></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="newProductCount" placeholder="Insert New Product Count"></el-input>
                </el-form-item>
                <el-button type="primary" size="mini" @click="doUpdateProduct" :loading="loadingBtnUpdateProduct">Save</el-button>
                <el-button type="danger" size="mini" @click="dialogUpdateProduct=false">Close</el-button>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import config from '../../config'
import api from '@/networkClient'
export default {
    props: {
        propLoading: {
            type: Boolean,
            default: true
        },
        propProduct: {
            type: Array,
            default: []
        },
        propServices: {
            type: Array,
            default: []
        },
        propAdditionalProduct: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            loading: {
                page: false,
                createServiceAdditional: false,
                buttonDeleteService: false,
                loadingConsumenProductAdditional: false
            },
            dialogAddAdditionalServiceUser: false,
            loadingBtnAddServiceAdditional: false,
            loadingBtnAddProductAdditional: false,
            loadingBtnRemoveProductAdditional: false,
            loadingConsumenProductAdditional: false,
            loadingPage: false,
            getAdditionalServiceLoading: false,
            additionalServiceLoadingButton: false,
            loadingBtn: false,
            form: {
                serviceName: ""
            },
            product: this.propProduct,
            productAdditional: this.propAdditionalProduct,
            services: this.propServices,
            listProduct: [],
            selectedProductAssigned: '',
            options: [{
                type: 'shorten',
                value: 'shorten',
                label: 'Shorten URL'
            },{
                type: 'analytic',
                value: 'dashboard_analytic',
                label: 'Dashboard Analytic'
            },{
                type: 'telegram',
                value: 'telegram',
                label: 'Telegram'
            },{
                type: 'auditrail',
                value: 'auditrail',
                label: 'Auditrail'
            },{
                type: 'line',
                value: 'line',
                label: 'Line'
            },{
                type: 'livechat',
                value: 'livechat',
                label: 'Live Chat'
            },{
                type: 'campaign',
                value: 'telkomsel_info',
                label: 'Telkomsel Info'
            }],
            value: '',
            valueSelectService: '',
            dialogUpdateProduct: false,
            selectedProductCount: '',
            newProductCount: '',
            loadingBtnUpdateProduct: false
        }
    },
    methods: {
        formatPrice(value) {
            if(typeof value == "string") value = parseFloat(value)
            if(value == null || value == "") return "-"
			return value.toLocaleString('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: Number.isInteger(value) ? 0 : 4 })
        },
        
        capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
                if(string.split("_").length > 0){
                    let title = []
                    _.map(string.split("_"), (str) => {
                        title.push(str.charAt(0).toUpperCase() + str.slice(1))
                    })
                    return title.join(" ")
                } else {
                    return string.charAt(0).toUpperCase() + string.substring(1);
                }
			}
        },
        doShowDialogUpdateProduct(key){
            this.dialogUpdateProduct = true
            this.selectedProductCount = this.product[key].count
        },
        loadProduct(){
			this.listProduct = []
            api({
				url: config.baseApi + "product",
				params: {
					per_page: 100
				},
                method: 'get'
            })
            .then(res => {
				var products = res.data.data.product
				// console.log(products)
				products.forEach(element => {
					this.listProduct.push({
                        type: element.type,
						productName:element.productName,
						aliasName:element.aliasName,
						productSKU:element.productSKU
					})
				});
            })
            .catch(err => {
                console.log(error)
            })
        },
        
        async addServiceAdditionalUser(){
            if(_.isEmpty(this.valueSelectService)){
				this.$message.error({
					showClose: false,
					message: 'All field is required'
				});
				return
            }
            this.loadingBtnAddServiceAdditional = true
            let custId = this.$route.params.consumen
			await api({
				method:'post',
				url:config.baseApi+'consumen/'+custId+'/addServiceAdditionalUser',
				data:{
					"name": this.valueSelectService
				}
			}).then(res => {
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                    this.dialogAddAdditionalServiceUser=false
                    this.loadingBtnAddServiceAdditional = false
				} else {
                    this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
                    this.clear()
                    this.getAdditionalService()
                    this.dialogAddAdditionalServiceUser=false
                    this.loadingBtnAddServiceAdditional = false
				}
			}).catch(err => {
                return err
                this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                this.dialogAddAdditionalServiceUser=false
            this.loadingBtnAddServiceAdditional = false
			})
            
        },
        detailConsumenProduct(){
            this.loadingConsumenProductAdditional = true
            let custId = this.$route.params.consumen
            api({
                url: config.baseApi + 'consumen/' + custId + "/product_additional",
                method: 'get'
            })
            .then(res => {
                // console.log(res)
                if(res.data.data.length > 0) this.product = res.data.data
                else this.product = [ { product: [] } ]
                // console.log('Products : ', this.product)
            })
            .catch(err => {
                return err
                this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
            })
            this.loadingConsumenProductAdditional = false
        },
        getAdditionalService(){
            this.loading.page = true
            this.getAdditionalServiceLoading = true
            let custId = this.$route.params.consumen
            api({
                url: config.baseApi + 'consumen/' + custId + "/additional-services",
                method: 'get'
            })
            .then(res => {
                // console.log('res data additional',res)
                if(res.data.data.services.length > 0) {
                    this.services = res.data.data.services
                    var productAddt = this.services
                    productAddt.forEach(element => {
                        // console.log("element product additional",element)
                        this.productAdditional = element.product
                        if(this.productAdditional != undefined){
                            // console.log('this prod additional di additinal',this.productAdditional)
                        }
                    });
                }
                else {
                    this.services = [ { services: [] } ]
                } 
                // this.product = res.data.data.services[0].product
                // var productAdditional = res.data.data.services.product
                // productAdditional.forEach(element => {
                //     this.additionalProduct = element
                //     console.log('additional product',this.additionalProduct)
                // });
            })
            .catch(err => {
                return err
            })
            this.getAdditionalServiceLoading = false
            this.loading.page = false
        },
        addProductAdditionalUser(){
            if(_.isEmpty(this.selectedProductAssigned)){
				this.$message.error({
					showClose: false,
					message: 'All field is required'
				});
				return
            }
            this.loadingBtnAddProductAdditional = true
            let custId = this.$route.params.consumen
            // console.log('this.selectedProductAssigned',this.selectedProductAssigned)
			api({
				method:'post',
				url:config.baseApi+'consumen/'+custId+'/addProductAdditionalUser',
				data:{
                    // type: '',
					// product:this.selectedProductAssigned
					type:this.selectedProductAssigned
				}
			}).then(res => {
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                    this.dialogAddAdditionalServiceUser=false
                    this.loadingBtnAddProductAdditional = false
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
                    this.getAdditionalService()
                    this.dialogAddAdditionalServiceUser=false
                    this.loadingBtnAddProductAdditional = false
				}
			}).catch(err => {
                return err
                this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                this.dialogAddAdditionalServiceUser=false
                this.loadingBtnAddProductAdditional = false
			})
        },
        doUpdateProduct(){
            if(_.isEmpty(this.newProductCount)){
                this.$message.error({
                    showClose: false,
                    message: 'Product count is required'
                });
                return
            }
            this.loadingBtnUpdateProduct = true
            let custId = this.$route.params.consumen
            api({
                url: config.baseApi + 'consumen/'+custId+'/update_additional_product',
                method: 'patch',
                data: {
                    "serviceName":"shortenUrl",
                    "count": parseInt(this.newProductCount)
                }
            }).then(res => {
                if(res.data.ec != 200){
                    this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                    this.dialogUpdateProduct = false
                } else {
                    this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
                    this.dialogUpdateProduct = false
                    this.getAdditionalService()
                }
            }).catch(err => {
                return err
            })
            this.loadingBtnUpdateProduct=false
        },
        removeAdditionalService(name){
            let custId = this.$route.params.consumen
            this.additionalServiceLoadingButton = true
            this.$swal({
              title: 'Anda yakin akan menghapus servis ini?',
              text: 'Data yang ada didalamnya akan ikut terhapus. Data tersebut meliputi akses ke menu/website yang bersangkutan, data token, dan data penting lainnya',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes Delete it!',
              cancelButtonText: 'No, Keep it!',
              showCloseButton: true,
              showLoaderOnConfirm: true
            }).then(() => {
                this.loadingPage = true
                 api({
                    url: config.baseApi + 'consumen/'+custId+'/additional-services',
                    method: 'delete',
                    data: {
                        serviceName: name
                    }
                }).then(res => {
                    if(res.data.ec != 200){
                        this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    } else {
                        this.$swal(this.$t('success'), 'Success', "success")
                        this.valueSelectService = ''
                        this.services = this.propServices
                        this.product = this.propProduct
                        // this.detailConsumenProduct()
                        this.getAdditionalService()
                        this.loadingPage = false
                        this.additionalServiceLoadingButton = false
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                });
                this.additionalServiceLoadingButton = false
            });
        },
        removeProductAdditional(product){
            this.loadingBtnRemoveProductAdditional = true
            let custId = this.$route.params.consumen
            this.$swal({
              title: 'Are you sure?',
              text: 'You can\'t revert your action',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes Delete it!',
              cancelButtonText: 'No, Keep it!',
              showCloseButton: true,
              showLoaderOnConfirm: true
            }).then(() => {
                this.loadingPage = true
                api({
                    url: config.baseApi + 'consumen/'+custId+'/remove-product',
                    method: 'delete',
                    data: {
                        id: product
                    }
                }).then(res => {
                    if(res.data.ec != 200){
                        this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    } else {
                        this.$swal(this.$t('success'), 'Success', "success")
                        this.product = this.propProduct
                        this.detailConsumenProduct()
                        this.getAdditionalService()
                        this.loadingPage = false
                        this.loadingBtnRemoveProductAdditional = false
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                });
                this.loadingBtnRemoveProductAdditional = false
            });
        },
        clear(){
            this.valueSelectService = ''
            this.selectedProductAssigned = ''
            this.newProductCount = ''
		}
    },
    created() {
        this.loadProduct()
        // this.detailConsumenProduct()
        // this.getAdditionalService()
    },
    mounted(){
        this.getAdditionalService()
        // this.propAdditionalProduct
        // this.propServices
    },
    watch: {
        propServices: function(){
            this.services = this.propServices
        }
        // propLoading: function() {
        //     this.loadingPage = this.propLoading
        //     if (this.propServices) {
        //         this.services = this.propServices
        //         // this.productAdditional = this.propAdditionalProduct
        //         let product = this.services.find(v => {
        //             return v.product.find(p => { return /short/ig.test(p.productSKU) })
        //         })
        //         if (product) {
        //             this.product = product.product
        //         }
        //     } 
        //     else if(this.propAdditionalProduct) {
        //         this.productAdditional = this.propAdditionalProduct
        //     }
        // }
    }
}
</script>
<style lang="scss" scoped>
.topright {
  position: absolute;
  top: 8px;
  right: 16px;
  font-size: 18px;
}
.img-center {
    display: block;
    margin-bottom: 60px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 60px;
    width: 10%;
}
</style>